import { action, makeObservable, observable } from 'mobx'

import * as e from '~/client/src/shared/stores/EventStore/eventConstants'

import WorkflowType from '../../models/WorkflowType'
import WorkflowTypesStore from '../../stores/domain/WorkflowTypes.store'
import EventsStore from '../../stores/EventStore/Events.store'
import CommonStore from '../../stores/ui/Common.store'

export default class WorkflowTypeSelectorStore {
  @observable public selectedWorkflowTypeId: string = null

  public constructor(
    private readonly eventsStore: EventsStore,
    private readonly workflowTypesStore: WorkflowTypesStore,
    private readonly commonStore: CommonStore,
  ) {
    makeObservable(this)
  }

  public get isLoading(): boolean {
    const { loading } = this.eventsStore.appState
    return (
      loading.get(e.INIT_AUTH_USER) ||
      loading.get(e.LOGIN_WITH_INVITE_KEY) ||
      loading.get(e.INIT_APP) ||
      loading.get(e.INIT_APP_2) ||
      loading.get(e.LOAD_AND_LISTEN_TO_WORKFLOW_TYPES) ||
      loading.get(e.LOAD_AND_LISTEN_TO_WORKFLOW_CATEGORIES)
    )
  }

  public get workflowTypes(): WorkflowType[] {
    return this.workflowTypesStore.enabledTypes
  }

  @action.bound
  public selectWorkflowType(workflowTypeId: string) {
    this.selectedWorkflowTypeId = workflowTypeId
  }

  @action.bound
  public applySelection() {
    if (this.selectedWorkflowTypeId) {
      this.eventsStore.appState.preSelectedPermitTypeId =
        this.selectedWorkflowTypeId
      this.commonStore.displayHomeView()
    }
  }
}
